import { render, staticRenderFns } from "./Phone_Nav.vue?vue&type=template&id=91847bec&scoped=true"
import script from "./Phone_Nav.vue?vue&type=script&lang=js"
export * from "./Phone_Nav.vue?vue&type=script&lang=js"
import style0 from "./Phone_Nav.vue?vue&type=style&index=0&id=91847bec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91847bec",
  null
  
)

export default component.exports